import { Injectable } from '@angular/core';
import {
  ArrivalDepartureNoticeInformationData,
  ArrivalDepartureNoticeInformationEmail,
  ArrivalDepartureNoticeInformationParts,
} from '@common/interfaces/mybooking/modals/passenger-information-input/arrival-departure-notice-information.interface';
import { PassengerInformationInputModalCommonService } from './passenger-information-input-modal.common.service';

/**
 * 発着通知連絡先情報 service
 */
@Injectable()
export class ArrivalDepartureNoticeInformationService {
  constructor(private _s04CommonSvc: PassengerInformationInputModalCommonService) {}

  /**
   * 発着通知連絡先情報　初期値の作成
   * @param contactsTraveler FIXME: Đã hardcode interface ở sdk. chờ version sdk mới
   * @returns 発着通知連絡先情報　初期値
   */
  createData(contactsTraveler: any): ArrivalDepartureNoticeInformationData {
    const departureArrivalNotifications = contactsTraveler?.departureArrivalNotifications;
    const departureArrivalNotifyEmails: Array<ArrivalDepartureNoticeInformationEmail> =
      // FIXME: Đã hardcode interface ở sdk. chờ version sdk mới
      departureArrivalNotifications?.map((item: any) => ({
        recipient: item.emails.recipient,
        address: item.emails.address,
        confirmMailAddress: item.emails.address,
        lang: item.emails.lang,
      })) ?? [];

    return {
      emails: departureArrivalNotifyEmails,
      isError: false,
    };
  }

  /**
   * 発着通知連絡先情報 設定値の作成
   * @param contactsTraveler FIXME: Đã hardcode interface ở sdk. chờ version sdk mới
   * @returns 発着通知連絡先情報 設定値
   */
  createParts(contactsTraveler: any): ArrivalDepartureNoticeInformationParts {
    const departuteArrivalNotifyLength = contactsTraveler.departureArrivalNotifications?.length ?? 0;

    return {
      isDisplay: departuteArrivalNotifyLength > 0,
      // 発着通知連絡先情報編集可否
      isArrivalDepartureNoticeInfoEditable: !Boolean(departuteArrivalNotifyLength >= 3),
      registrationLabel: '',
      registrationClass: '',
    };
  }

  /** 言語がリストにあるか判定 */
  checkLang(lang?: string): boolean {
    const pd065 = this._s04CommonSvc.masterData.listData.filter((data) => data.data_code === 'PD_065');

    if (!lang) {
      return false;
    }

    return pd065?.some((language) => language?.country_3letter_code?.toLocaleLowerCase() === lang.toLocaleLowerCase());
  }
}
